export default {"src":"/_next/static/media/search.8ceae981.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};